import React, {FC, ReactElement} from "react";
import 'react-quill/dist/quill.snow.css';
import ReactQuill from "react-quill";

interface IProps {
    value?: string
    onChange: (value: string) => void
}

const modules = {
    toolbar: [
        [{font: []}, {size: []}],
        [{align: []}, 'direction'],
        ['bold', 'italic', 'underline', 'strike'],
        [{color: []}, {background: []}],
        [{script: 'super'}, {script: 'sub'}],
        ['blockquote', 'code-block'],
        [{list: 'ordered'}, {list: 'bullet'}, {indent: '-1'}, {indent: '+1'}],
        ['link'],
    ],
};


export const HtmlTextEditor: FC<IProps> = ({value, onChange,}): ReactElement => {
    return <ReactQuill theme="snow" modules={modules} value={value} onChange={onChange}/>
};